import React, { Component, useEffect } from 'react';
import queryString from 'query-string';
import Toast from '../../../engage/utils/Toast';
import CmsAPI from '../../../common/apis/CmsAPI';
import cx from 'classnames';
import Nav from '../../common/component/Nav/Nav';
import MainContainer from '../../common/component/MainContainer';
import FormContainer from '../../common/component/FormContainer';
import Footer from '../../common/component/Footer';
import { CustomInput } from '../../../engage/components/Input/Input';
import styles from './verify-email.module.scss';
import { CustomButton } from '../../../engage/components/Button/Button';
import happy from '../../assets/images/happy.gif';
import sad from '../../assets/images/sad.png';
import MobileHeader from '../../../engage/components/MobileHeader';
import ProtectedPageSidebar from '../../../engage/components/Sidebar/ProtectedPageSidebar';
import Spinner from '../../../common/components/Spinner';

export default class VerifyEmailPage extends Component {
  state = {
    loading: false,
    email: '',
    username: '',
    code: null,
    confirmed: false,
    resent: false,
    error: false,
    errorType: null,
    message: {
      title: '',
      message: '',
      logo: '',
      action: null,
    },
    isMobileView: false,
  };

  messages = {
    confirmed: {
      title: 'Your account is confirmed',
      message: 'You can now start making video with Vormats! Login to the app with your email and password.',
      logo: happy,
      action: 'Continue to Login',
      url: '/login',
    },
    alreadyActive: {
      title: 'Your account is already confirmed',
      message: "You've already confirmed your account. Login to the app with your email and password.",
      logo: sad,
      action: null,
    },
    expired: {
      title: 'This link is expired or invalid',
      message: 'Confirmation links expire after 24 hours. We’ve sent you a new confirmation link, check your inbox.',
      logo: sad,
      action: null,
    },
    cantActivate: {
      title: "We can't confirm your account",
      message: "Something has gone wrong. Please send us a message. We'll get you up and running.",
      logo: sad,
      action: 'Contact Helpdesk',
    },
    emailResent: {
      title: 'Confirmation email has been resent',
      message: 'A new confirmation email has been sent to your email inbox. Follow the steps to confirm your account.',
      logo: sad,
      action: null,
    },
    unknown: {
      title: 'Unknown error',
      message: '',
      logo: sad,
      action: 'Contact Helpdesk',
    },
  };

  componentDidMount() {
    const searchWithPlusSign = this.props.location.search.replaceAll('+', '%2B');
    const qs = queryString.parse(searchWithPlusSign);
    console.log('Query String:', qs);
    const mediaMatch = window.matchMedia('(max-width: 900px)');
    this.setState({
      email: qs.email,
      username: qs.username,
      code: qs.code,
      isMobileView: mediaMatch.matches,
    });

    // If a code is set, try to confirm this email
    if (qs.code) {
      this.confirm(qs.username, qs.code)
        .then(response => {
          console.log('Confirm response', response);

          if (response.result != null && response.result) {
            this.setState({
              confirmed: true,
              message: this.messages.confirmed,
            });
          } else {
            let message = this.messages.cantActivate;

            switch (response.data) {
              case 'NotAuthorizedException':
                message = this.messages.alreadyActive;
                break;
              case 'CodeMismatchException':
                this.resend(); // Automatically resend email on code mismatch
                //message = this.messages.expired
                message = this.messages.emailResent; // We won' ever show expired message, since we automatically resend the confirmation email
                break;
              case 'ExpiredCodeException':
              case 'EmailResent':
                message = this.messages.emailResent;
                break;
              default:
                break;
            }

            this.setState({
              error: true,
              errorType: response.data,
              message: message,
            });
          }
        })
        .catch(e => console.log(e));
    }
  }

  confirm = async (username, code) => {
    this.setState({ loading: true });

    let response = await CmsAPI.confirmEmail(username, code);

    this.setState({ loading: false });

    return response;
  };

  resend = async () => {
    this.setState({ loading: true });

    try {
      await CmsAPI.resendConfirmEmail(this.state.email);
      Toast.success('We resent the email!');
    } catch (e) {
      // TODO: Get actual error message from the API response, now it simply shows "Network error"
      console.log(e);
      Toast.error('Unable to resend email, perhaps your account has already been activated');
    }

    this.setState({ loading: false });
  };

  render() {
    const { loading, code, email, username, confirmed, resent, error, errorType, message, isMobileView } = this.state;
    return (
      <>
        {!isMobileView && <Nav />}
        <MobileHeader libraryMode={false} />
        <MainContainer className={cx('content-padding play-bg', { [styles.clearBackground]: isMobileView })}>
          {isMobileView && <ProtectedPageSidebar />}
          <div>
            <div>
              <FormContainer title="Verify your email">
                <div className={styles.formContainer}>
                  {code && loading && (
                    <div className={styles.authCard}>
                      <div className={styles.verifyText}>
                        <Spinner width="30px" height="30px" size="3px" className={styles.spinnerIcon} />
                      </div>
                    </div>
                  )}

                  {code && !loading && (
                    // After user clicked confirm email link in their inbox
                    <div className={styles.authCard}>
                      <div className={styles.verifyText}>
                        <a href="https://vormats.com" target="_blank" aria-label="Open Vormats">
                          <img src={message.logo} alt="Logo" id="logo" />
                        </a>

                        <br />
                        <br />

                        <h1>{message.title}</h1>

                        <p>{message.message}</p>

                        {message.action !== null && (
                          <CustomButton
                            className={styles.submitButton}
                            label={message.action}
                            variant="primary"
                            onClick={() =>
                              message.url ? this.props.history.push('/login', { email }) : window.open('https://vormats.com', '_self')
                            }
                          />
                        )}
                      </div>
                    </div>
                  )}

                  {!code && (
                    // Notification after registration showing user has received an email to confirm their email address
                    <div className={styles.authCard}>
                      <div className={styles.verifyText}>
                        {isMobileView
                          ? 'We sent you an email. You may need to check your spam folder.'
                          : 'We sent a verification link to the email you provided. Click the link to verify your email address. You may need to check your spam folder.'}
                      </div>

                      <CustomInput
                        name="email"
                        fieldName="Email address"
                        value={this.state.email}
                        validateMessage="Your email or password is incorrect. Please try again."
                        disabled={true}
                        customStyles={{ backgroundColor: 'transparent' }}
                      />

                      <CustomButton
                        className={styles.submitButton}
                        label="Continue"
                        variant="primary"
                        onClick={() => this.props.history.push('/login')}
                        disabled={!this.state.email}
                      />
                      <div className={styles.formFooter}>
                        <p>{isMobileView ? 'Didn’t receive it?' : 'Don’t see it in your inbox?'}</p>
                        <div>
                          <CustomButton
                            onClick={this.resend}
                            loading={loading}
                            loadingText="Re-sending..."
                            disabled={!this.state.email}
                            label="Resend"
                            variant="link"
                            className={styles.linkButton}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </FormContainer>
            </div>
          </div>
        </MainContainer>
        <Footer />
      </>
    );
  }
}
